import { FiatOrCryptoAmount } from '@/components/atoms/Amount/Amount'
import { useCoinflipStore } from './CoinflipProvider'
import { memo } from 'react'
import { AnimatedAmount } from '@/components/atoms/AnimatedAmount/AnimatedAmount'
import { useStoreWithEqualityFn } from 'zustand/traditional'
import { getTokenByDenom } from '@/services/token-service'
import { SupportedCurrencies, TokenMoney } from '@ninjablaze/sdk-ts'
import { useFiatCurrencyStore } from '@/context/FiatCurrencyStore'

export const PayableAmount = memo(() => {
  const {
    view: { roundState },
    form,
  } = useCoinflipStore()

  const gameSteps = useStoreWithEqualityFn(
    useCoinflipStore,
    (state) => state.gameSteps,
    (a, b) => {
      return a.length == b.length && a.at(-1)!.payable.isEqualTo(b.at(-1)!.payable)
    }
  )

  const payable = gameSteps[roundState.currentStep].payableFormat.toFixed(3)

  return (
    <FiatOrCryptoAmount
      denom={form.fields.denom}
      iconSize={'14px'}
      value={payable}
      currencyStyles={{
        color: 'rgba(255, 255, 255, 0.4)',
      }}
    />
  )
})

export const NextRoundPayableAmount = () => {
  const {
    view: { roundState },
    form,
  } = useCoinflipStore()

  const gameSteps = useStoreWithEqualityFn(
    useCoinflipStore,
    (state) => state.gameSteps,
    (a, b) => {
      return a.length == b.length && a.at(-1)!.payable.isEqualTo(b.at(-1)!.payable)
    }
  )

  const isUsd = useFiatCurrencyStore((s) => s.isUsd())
  const usdcToFiat = useFiatCurrencyStore((s) => s.usdcToFiat)
  const getSymbol = useFiatCurrencyStore((s) => s.getSymbol)

  const payable = gameSteps[roundState.currentStep + 1]?.payable || '0'
  const denom = form.fields.denom
  const isUsdc = getTokenByDenom(denom)?.currency === SupportedCurrencies.USDC
  const humanUsdc = new TokenMoney(payable, denom).humanNumber

  if (isUsdc && !isUsd) {
    return (
      <AnimatedAmount
        precision={2}
        minWidth={'20px'}
        suffix={getSymbol()}
        amountProps={{
          wrapperStyles: { fontSize: 'sm' },
          currencyStyles: { display: 'none' },
          iconStyles: { display: 'none' },
          denom,
        }}
        value={usdcToFiat(humanUsdc)}
        duration={{ firstRender: 1, rendered: 0.5 }}
      />
    )
  }

  return (
    <AnimatedAmount
      precision={getTokenByDenom(denom).precisions}
      minWidth={'20px'}
      amountProps={{
        wrapperStyles: {
          fontSize: 'sm',
        },
        currencyStyles: {
          display: 'none',
          color: 'rgba(255, 255, 255, 0.4)',
        },
        iconMono: true,
        iconSize: 4,
        denom,
      }}
      value={humanUsdc}
      duration={{
        firstRender: 1,
        rendered: 0.5,
      }}
    />
  )
}
